import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "./secondfotter.css";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const footerLinks = [
  {
    title: "Coworking Space",
    mainPath: "/coworking-space/",
    links: [
      {
        name: "Coworking Space in Gurgaon",
        path: "/coworking-space/gurgaon/",
      },
      { name: "Coworking Space in Delhi", path: "/coworking-space/delhi/" },
      { name: "Coworking Space in Noida", path: "/coworking-space/noida/" },
      {
        name: "Coworking Space in Hyderabad",
        path: "/coworking-space/hyderabad/",
      },
    ],
  },
  {
    title: "Virtual Office",
    mainPath: "/workspace-solutions/virtual-office/",
    links: [
      {
        name: "Virtual Office in Gurgaon",
        path: "/workspace-solutions/virtual-office/gurgaon/",
      },
      {
        name: "Virtual Office in Delhi",
        path: "/workspace-solutions/virtual-office/delhi/",
      },
      {
        name: "Virtual Office in Noida",
        path: "/workspace-solutions/virtual-office/noida/",
      },
      {
        name: "Virtual Office in Hyderabad",
        path: "/workspace-solutions/virtual-office/hyderabad/",
      },
    ],
  },
  {
    title: "Office Space",
    mainPath: "/workspace-solutions/office-space/",
    external: true,
    links: [
      {
        name: "Office Space in Gurgaon",
        path: "/workspace-solutions/office-space/gurgaon/",
      },
      {
        name: "Office Space in Delhi",
        path: "/workspace-solutions/office-space/delhi/",
      },
      {
        name: "Office Space in Noida",
        path: "/workspace-solutions/office-space/noida/",
      },
      {
        name: "Office Space in Hyderabad",
        path: "/workspace-solutions/office-space/hyderabad/",
      },
    ],
  },
  {
    title: "Day Pass",
    mainPath: "/workspace-solutions/flexible-office/day-pass/",
    links: [
      {
        name: "Day Pass in Gurgaon",
        path: "/workspace-solutions/flexible-office/day-pass/gurgaon/",
      },
      {
        name: "Day Pass in Noida",
        path: "/workspace-solutions/flexible-office/day-pass/noida/",
      },
      {
        name: "Day Pass in Delhi",
        path: "/workspace-solutions/flexible-office/day-pass/delhi/",
      },
      {
        name: "Day Pass in Hyderabad",
        path: "/workspace-solutions/flexible-office/day-pass/hyderabad/",
      },
    ],
  },
  {
    title: "Meeting Rooms",
    mainPath: "/workspace-solutions/flexible-office/meeting-rooms/",
    links: [
      {
        name: "Meeting Rooms in Gurgaon",
        path: "/workspace-solutions/flexible-office/meeting-rooms/gurgaon/",
      },
      {
        name: "Meeting Rooms in Noida",
        path: "/workspace-solutions/flexible-office/meeting-rooms/noida/",
      },
      {
        name: "Meeting Rooms in Delhi",
        path: "/workspace-solutions/flexible-office/meeting-rooms/delhi/",
      },
      {
        name: "Meeting Rooms in Hyderabad",
        path: "/workspace-solutions/flexible-office/meeting-rooms/hyderabad/",
      },
    ],
  },
];

const Secondfotter = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const containerRef = useRef(null);

  const toggleGroup = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setOpenIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="second-fotter-wrapper">
      <div className="second-footer-container" ref={containerRef}>
        {footerLinks.map((section, index) => (
          <div key={index} className="second-footer-group">
            <div
              className="second-footer-heading"
              onClick={() => toggleGroup(index)}
            >
              {section.external ? (
                <a
                  href={section.mainPath}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="custom-link"
                >
                  <h4>{section.title}</h4>
                </a>
              ) : (
                <Link to={section.mainPath} target="_blank" className="custom-link">
                  <h4>{section.title}</h4>
                </Link>
              )}
              <span className="second-footer-toggle-icon">
                {openIndex === index ? <IoIosArrowUp /> : <IoIosArrowDown />}
              </span>
            </div>

            <div
              className={`second-footer-links ${
                openIndex === index ? "open" : ""
              }`}
            >
              {section.links.map((link, i) =>
                section.external ? (
                  <a
                    key={i}
                    href={link.path}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {link.name}
                  </a>
                ) : (
                  <Link key={i} to={link.path} target="_blank">
                    {link.name}
                  </Link>
                )
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Secondfotter;